import angular from 'angular';
import CategoriesSliderFilter from './categories-slider-filter.component';

let CategoriesSliderFilterModule = angular.module('catalog.categoriesSliderFilter', [])
  .component('categoriesSliderFilter', CategoriesSliderFilter);

export default CategoriesSliderFilterModule;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/categories-filter/categories-slider-filter/categories-slider-filter.js
 **/